import { useAppSelector } from '../../store/store';
import ImgWithFallback from '../ui/ImgWithFallback';

import earLeftSlots from '../../assets/img/item_slots/Ear_Left.png'
import earLeftSlotsWebp from '../../assets/img/item_slots/Ear_Left.webp'
import earRightSlots from '../../assets/img/item_slots/Ear_Right.png'
import earRightSlotsWebp from '../../assets/img/item_slots/Ear_Right.webp'
import neckSlots from '../../assets/img/item_slots/Neck.png'
import neckSlotsWebp from '../../assets/img/item_slots/Neck.webp'
import ringSlots from '../../assets/img/item_slots/Ring.png'
import ringSlotsWebp from '../../assets/img/item_slots/Ring.webp'

const CharacterWindowJewerly = () => {
    const mainCharacter = useAppSelector(state => state.userReducer.character)

    return (
        <>
            <li className="equipment__slot">
                <ImgWithFallback src={earLeftSlotsWebp} fallbackSrc={earLeftSlots} />
            </li>
            <li className="equipment__slot">
                <ImgWithFallback src={earRightSlotsWebp} fallbackSrc={earRightSlots} />
            </li>
            <li className="equipment__slot">
                <ImgWithFallback src={neckSlotsWebp} fallbackSrc={neckSlots} />
            </li>
            <li className="equipment__slot">
                <ImgWithFallback src={ringSlotsWebp} fallbackSrc={ringSlots} />
            </li>
            <li className="equipment__slot">
                <ImgWithFallback src={ringSlotsWebp} fallbackSrc={ringSlots} />
            </li>
            <li className="equipment__slot">
                <ImgWithFallback src={ringSlotsWebp} fallbackSrc={ringSlots} />
            </li>
        </>
    );
};

export default CharacterWindowJewerly;